import { Box, Typography } from '@mui/material'
import { useStyles } from './styles'

export default function StoreStatusChip({ value }: { value: any }) {
  if (!value?.text || !value?.color) return null

  const styles = useStyles(value.color, 'medium')
  return (
    <Box sx={styles.container}>
      <Box sx={styles.chip({ fit: true })}>
        <Typography sx={styles.text} className="custom-lines">
          {value.text}
        </Typography>
      </Box>
    </Box>
  )
}
